import { themes } from 'kb-shared';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  height: 70px;
  background-color: ${themes.colors.yellow.lightestYellow};
  justify-content: space-between;
  box-shadow: ${themes.shadows.card.level1};
  padding: 0px 20px 0px 20px;
  overflow: visible;
  z-index: 1;
  @media screen and ${themes.queries.mobile} {
    padding: 0px 70px 0px 70px;
  }
  @media screen and ${themes.queries.minLargeDesktop} {
    flex-direction: column;
    height: 90px;
    padding-top: 10px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media screen and ${themes.queries.minLargeDesktop} {
    justify-content: space-between;
    margin-top: 6px;
  }
`;

export const LogoAndProgressWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DashboardNavigation = styled.div`
  cursor: pointer;
  width: 100%;
  padding-left: 12px;
  text-decoration: underline;
  @media screen and ${themes.queries.mobile} {
    font-size: 13px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  @media screen and ${themes.queries.minLargeDesktop} {
    justify-content: flex-start;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  min-width: 110px;
  height: 24px;
  @media screen and ${themes.queries.mobile} {
    display: none;
  }
`;

export const SelectWrapper = styled.div`
  width: 200px;
  @media screen and ${themes.queries.mobile} {
    width: 100%;
  }
  > div {
    > div {
      > div {
        padding-left: 0;
        padding-right: 0;
        border-bottom: none;
        background-color: ${themes.colors.yellow.lightestYellow};

        > div {
          padding: 0;
        }
      }
    }
    > div div {
      font-size: 16px !important;
    }
  }
`;

export const CompletedLabel = styled.div`
  background: ${({ theme }) => theme.colors.neutral.primaryNavy};
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  padding: 6px 12px;
  margin: 0 0 0 16px;
  line-height: 1.2;
  span {
    display: none;
  }
  @media ${({ theme }) => theme.queries.minTablet} {
    span {
      display: inline;
    }
  }
`;
